import { useTheme } from "@/theme/ThemeProvider";
import { Stack } from "expo-router";

export default function ClubLayout() {
  const { theme } = useTheme();
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: theme.color.bg },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="new" />
      <Stack.Screen name="[itemId]" />
    </Stack>
  );
}
